/* eslint-disable no-magic-numbers */
import React, { memo } from "react";
import { getPositionPercent, getTimeScale } from "./helpers";
import "./style/ProgressBar.scss";

interface ITimeCodeItemProps {
  currentTime: number;
  seekHoverTime: number;
  startTime: number;
  endTime: number;
  maxTime: number;
  trackWidth: number | undefined;
}

export const TimeCodeItem: React.FC<ITimeCodeItemProps> = memo(
  ({
    startTime,
    maxTime,
    endTime,
    trackWidth = 0,
    currentTime,
    seekHoverTime,
  }) => {
    const positionPercent = getPositionPercent(maxTime, startTime);
    const translateX = (trackWidth / 100) * positionPercent;
    const timeDiff = endTime - startTime;
    const widthPercent = (timeDiff / maxTime) * 100;
    const width = (trackWidth / 100) * widthPercent;

    const currentTimeScale = getTimeScale(
      currentTime,
      startTime,
      endTime
    );

    const seekHoverTimeScale = getTimeScale(
      seekHoverTime,
      startTime,
      endTime
    );

    return (
      <div
        className="main"
        style={{
          width: `${width}px`,
          left: `${translateX}px`
        }}
      >
        <div
          className="inner-seek-block seek-hover"
          style={{ transform: `scaleX(${seekHoverTimeScale})` }}
        />

        <div
          className="inner-seek-block connect"
          style={{ transform: `scaleX(${currentTimeScale})` }}
        />
      </div>
    );
  }
);
